import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import 'bootstrap/dist/css/bootstrap.min.css';

import NavigationBar from './components/Layout/Navbar';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Dashboard from './components/Dashboard/Dashboard';
import PaymentList from './components/Payments/PaymentList';
import PaymentForm from './components/Payments/PaymentForm';
import PaymentDetail from './components/Payments/PaymentDetail';
import IncomeList from './components/Incomes/IncomeList';
import ExpenseList from './components/Expenses/ExpenseList';
import CategoryList from './components/Categories/CategoryList';
import FixedExpenseList from './components/FixedExpenses/FixedExpenseList';
import AdminPanel from './components/Admin/AdminPanel';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <NavigationBar />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/payments"
            element={
              <PrivateRoute>
                <PaymentList />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/payments/new"
            element={
              <PrivateRoute>
                <PaymentForm />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/payments/:id"
            element={
              <PrivateRoute>
                <PaymentDetail />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/incomes"
            element={
              <PrivateRoute>
                <IncomeList />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/expenses"
            element={
              <PrivateRoute>
                <ExpenseList />
              </PrivateRoute>
            }
          />

          <Route
            path="/categories"
            element={
              <PrivateRoute>
                <CategoryList />
              </PrivateRoute>
            }
          />

          <Route
            path="/fixed-expenses"
            element={
              <PrivateRoute>
                <FixedExpenseList />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin"
            element={
              <AdminRoute>
                <AdminPanel />
              </AdminRoute>
            }
          />
          
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
